<anota-modal 
  id="exit-intent-modal"
  type="center" 
  [visible]="visible" 
  (visibleChange)="handleVisibilityChange($event)"
  [anotaTitle]="currentVariant.title"
  [noButton]="true"
  (confirmModal)="handleAccept()">
  
  @if (currentVariant.imageSrc) {
    <div class="modal-image-container" [class.variant-b]="variant === 'variantB'">
      <img [src]="currentVariant.imageSrc" [alt]="currentVariant.title" class="modal-image" />
    </div>
  }

  <p class="modal-description">{{ currentVariant.subtitle }}</p>

  <div class="modal-actions">
    <anota-button
      type="primary"
      size="md"
      (click)="handleAccept()"
      class="cta-button">
      {{ currentVariant.ctaText }}
    </anota-button>
  </div>

</anota-modal>
